import { convertRemToPx } from '@hivebrite/design-system/Theme';
import { type Theme } from '@hivebrite/design-system/Theme';

type Direction = 'bottom' | 'left' | 'right' | 'top';

type PaddingDirectionValue = {
  [key in Direction]: number;
};

export const isPaddingTooBig = (
  value: PaddingDirectionValue | null,
  maxValue: number | null,
) => {
  if (!value) {
    return 0;
  }

  if (!maxValue) {
    return value;
  }

  return (
    value.top > maxValue ||
    value.left > maxValue ||
    value.right > maxValue ||
    value.top > maxValue
  );
};

export const shorthandParser = (value, direction) => {
  if (!value) {
    return 0;
  }

  const splittedValue = value.split(' ');
  let directions = {};

  switch (splittedValue.length) {
    case 2:
      directions = { top: 0, bottom: 0, left: 1, right: 1 };
      break;

    case 3:
      directions = { top: 0, left: 1, right: 1, bottom: 2 };
      break;

    case 4:
      directions = { top: 0, right: 1, bottom: 2, left: 3 };
      break;

    case 1:
    default:
      return parseInt(value, 10);
  }

  return parseInt(splittedValue[directions[direction]] || 0, 10);
};

export const getJustifyContent = (value?: string) =>
  value === 'left' ? 'flex-start' : value === 'right' ? 'flex-end' : value;

export const getAlignment = (value?: string) =>
  value === 'flex-start' ? 'left' : value === 'flex-end' ? 'right' : value;

export const getAlignSelf = (value?: string) =>
  value === 'left' ? 'start' : value === 'right' ? 'end' : value;

export const getAlignItems = (
  value?: boolean | 'bottom' | 'middle' | 'top',
) => {
  if (!value) {
    return;
  }

  if (value === 'top') {
    return 'flex-start';
  }

  if (value === 'middle') {
    return 'center';
  }

  if (value === 'bottom') {
    return 'flex-end';
  }
};

export const convertToPx = ({
  lineHeight,
  fontSize,
  theme,
}: {
  fontSize?: number | string;
  lineHeight?: number | string | null;
  theme: Theme;
}) => {
  if (Number.isInteger(lineHeight)) {
    return `${lineHeight}px`;
  }

  let value: number;

  if (!fontSize) {
    value = convertRemToPx(parseInt(theme.fontSizes[2], 10));
  } else if (typeof fontSize === 'string') {
    value = parseInt(fontSize, 10);
  } else {
    value = fontSize;
  }

  return `${value * theme.builder.typography.lineHeight}px`;
};

export const hasLink = ({ link }: { link?: string }) =>
  !!link?.trim() && link.trim() !== 'mailto:' && link.trim() !== 'tel:';

export const getStringifiedPadding = ({
  top = 0,
  right = 0,
  bottom = 0,
  left = 0,
}: PaddingDirectionValue) => `${top}px ${right}px ${bottom}px ${left}px`;
